import { imageAsset, link } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  ${link.fragment('link')},
  ${imageAsset.fragment('image')}
`

export const fragment = (name = 'textImageAndCallToAction') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
